import React, { Component } from 'react';
import {SkyLightStateless} from 'react-skylight';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { Field } from 'redux-form';
import { Breadcrumb, Grid, Button, ButtonToolbar, Panel } from 'react-bootstrap';
import { Translate, Localize } from 'react-redux-i18n';
import Calendar from '../Common/calendar';
import ChartModal from '../../containers/Purchase/chartModal';

class purchasePivotChart extends Component {
  constructor() {
    super();
    this.state = {
      purchasePivotChartOrders: null,
      chartModalOpen: false,
      date: null,
    }
    this.openChartModal = this.openChartModal.bind(this);
    this.closeChartModal = this.closeChartModal.bind(this);
    this.selectDate = this.selectDate.bind(this);
  }
  componentDidMount() {
    let date = new Date();
    let month = date.getMonth() + 1;
    if(month < 10)
      month = "0"+month;
    let year = date.getFullYear();
    month = month.toString();
    year = year.toString();
    this.props.fetchPurchasePivotChartOrders(month+year);
  }
  componentWillReceiveProps(nextProps) {
    if(nextProps.purchasePivotChartOrders && nextProps.purchasePivotChartOrders != this.props.purchasePivotChartOrders) {
      this.setState({purchasePivotChartOrders: nextProps.purchasePivotChartOrders});
    }
  }
  openChartModal() {
    this.setState({ chartModalOpen: true });
  }

  closeChartModal() {
    this.setState({ chartModalOpen: false });
  }
  selectDate(date) {
    this.setState({date: date})
  }
  render() {
    let createDialogStyle = {
        height: '600px',
        width: '600px',
        marginLeft: '-10%',
        top: '40%',
    };
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="purchase_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="quote_reference" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <ButtonToolbar>
          <Button
            bsStyle="primary"
            type="button">
            <em className="fa fa-print" /><Translate value="print" />
          </Button>
          <Button
            bsStyle="success"
            type="button">
            <em className="fa fa-download" /><Translate value="export" />
          </Button>
        </ButtonToolbar>
        <Grid id="purchase-pivot-chart">
          <Panel className="position-relative">
            <h1><Translate value="quote_reference_chart" /></h1>
            <Field
                name="Calendar"
                component={Calendar}
                data={this.state.purchasePivotChartOrders}
                openChartModal={this.openChartModal}
                fetchInfo={this.props.fetchPurchasePivotChartOrders}
                fetchPurchasePivotCharts = {this.props.fetchPurchasePivotCharts}
                selectDate={this.selectDate}
                type = "purchasePivotChart"
              />
          </Panel>
          <SkyLightStateless
            title="view details"
            dialogStyles={createDialogStyle}
            isVisible={this.state.chartModalOpen}
            onCloseClicked={() => { this.closeChartModal(); this.props.clearDuplicatedPurchasePivotChart(); }}
          >
              <ChartModal date={this.state.date}/>
          </SkyLightStateless>
        </Grid>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default purchasePivotChart;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchasePivotChart.jsx